import { connect } from 'react-redux'
import * as selector from '../../state/plan/selector'
import TreatmentClassification from "../plan/TreatmentClassification";
import * as action from "../../state/plan/action";

const mapStateToProps = (state, props) => {
    return {
        treatmentPlan: selector.selectTreatmentPlan(state),
    }
}

const mapDispatchToProps = {
    changeTreatmentPlan: action.changeTreatmentPlan,
    saveTreatmentPlan: action.saveTreatmentPlan
}


export default connect(mapStateToProps, mapDispatchToProps)(TreatmentClassification)



// WEBPACK FOOTER //
// ./src/modules/treatment/component/task-widget/TreatmentClassificationWidgetContainer.js